export default __webpack_public_path__ + "static/Aaron_profile-6342ef07bfe0c29e0c68f22b40ad1a17.png";